<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <vx-card class="overflow-hidden container-card m-auto"  :class="[`bg-${bgColor}`]" @click="goTo()" >
        <div slot="no-body">
            <div class="p-1 text-center">
                <div class="truncate">
                    <div :class="[`text-${txtColor}`]" class="font-bold">{{ statisticTitle }}</div>
                    <div :class="[`text-${txtColor}`]" class="font-bold text-xs" v-if="statisticSubtitle">{{ statisticSubtitle }}</div>
                    <div class="font-bold text-4xl" :class="[`text-${txtColor}`]">{{ statistic }}</div>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import _color from '@/assets/utils/color.js'

export default{
  props: {
    statistic: {
      type: [Number, String],
      required: true
    },
    statisticTitle: {
      type: String
    },
    bgColor: {
      type: String,
      default: 'primary'
    },
    txtColor: {
      type: String,
      default: 'white'
    },
    colorTo: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 100
    },
    type: {
      type: String,
      default: 'line'
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    hideChart: {
      type: Boolean,
      default: false
    },
    url:{
      type: String
    },
    statisticSubtitle: {
      type: String
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  watch: {
    themePrimaryColor () {
      this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex(this.color) } } })
    }
  },
  computed: {
    themePrimaryColor () {
      return this.$store.state.themePrimaryColor
    }
  },
  methods: {
    getHex (color) {
      if (_color.isColor(color)) {
        let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`)
        rgb = rgb.split(',')
        return `#${  ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1)}`
      }
      return color
    },
    gradientToColor (color) {
      const gradientToColors = {
        'primary': '#A9A2F6',
        'success': '#55DD92',
        'warning': '#ffc085',
        'danger': '#F97794'
      }

      return gradientToColors[color] ? gradientToColors[color] : gradientToColors['primary']
    },
    goTo () {
      if (this.url !== undefined) window.location.href = this.url
    }
  }
}
</script>
